import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Dashboard } from '@components/common'
import { useAppearance } from '@fourthwall/appearance'
import { Toasts, useCopyToClipboard } from '@fourthwall/components'
import { Stat, StatGroup } from '@fourthwall/module-analytics'
import { ShopUrlActionsDesktop } from '@fourthwall/module-shop-status-switch'
import { routing } from '@utils/routing'

import { useCurrentShop } from '../../../hooks/useCurrentShop'
import { ActiveVisitors } from '../ActiveVisitors'
import { AnalyticsDropdown } from './components/AnalyticsDropdown'
import { useHomeAnalytics } from './hooks/useHomeAnalytics'
import * as S from './styled'

export const HomeAnalytics = () => {
  const { appearance } = useAppearance()
  const { tabs, stats } = useHomeAnalytics()
  const { copyToClipboard } = useCopyToClipboard()
  const navigate = useNavigate()
  const { currentShopQuery } = useCurrentShop()

  return (
    <S.Container data-analytics-section="home-analytics">
      <S.TopBar>
        <S.TopBarLeftContent>
          <AnalyticsDropdown tabs={tabs} />
          <ActiveVisitors />
        </S.TopBarLeftContent>
        <ShopUrlActionsDesktop
          size="small"
          onDuplicateClick={() => {
            copyToClipboard(currentShopQuery.data?.baseUri || '')
            Toasts.notify('Copied to clipboard', { type: 'info' })
          }}
          onSettingsClick={() => {
            navigate(routing.settings.domain.self)
          }}
        />
      </S.TopBar>
      <Dashboard.Section.ScrollableContent hideScrollbar fullWidth>
        <StatGroup>
          {stats.map((props, index) => (
            <S.StatWrapper key={index}>
              <Stat {...props} appearance={appearance} />
            </S.StatWrapper>
          ))}
        </StatGroup>
      </Dashboard.Section.ScrollableContent>
    </S.Container>
  )
}
